/**
 * Get galaxyContainer
 */
export var getGalaxyContainer = function () { return document.getElementById('galaxy'); };
/**
 * Get nav element
 */
var getNav = function () {
    var galaxy = getGalaxyContainer();
    if (!galaxy) {
        return null;
    }
    return galaxy.querySelector('nav');
};
/**
 * Return list of service element
 */
var getList = function () {
    var nav = getNav();
    if (!nav) {
        return null;
    }
    return nav.querySelector('ul');
};
/**
 * Return control button group container
 */
var getButtonControls = function () {
    var galaxy = getGalaxyContainer();
    if (!galaxy) {
        return null;
    }
    return galaxy.querySelector('#galaxy-btn-group');
};
/**
 * Return next button element
 */
var getNextButton = function () {
    var galaxyButtons = getButtonControls();
    if (!galaxyButtons) {
        return null;
    }
    return galaxyButtons.querySelector('#btn-next');
};
/**
 * Return prevois button element
 */
var getPreviousButton = function () {
    var galaxyButtons = getButtonControls();
    if (!galaxyButtons) {
        return null;
    }
    return galaxyButtons.querySelector('#btn-previous');
};
/**
 * Initialise control button status
 */
var initButton = function () {
    var btnNext = getNextButton();
    var btnPrev = getPreviousButton();
    if (btnNext) {
        btnNext.disabled = false;
    }
    if (btnPrev) {
        btnPrev.disabled = true;
    }
};
/**
 * Return the next left position of the list
 *
 * @param list
 * @param nav
 * @param negative
 */
var getNextLeftPosition = function (list, nav, negative) {
    if (negative === void 0) { negative = false; }
    var sign = negative ? -1 : 1;
    var nbrWidthPart = 3;
    if (document.body.offsetWidth < 720) {
        nbrWidthPart = 2;
    }
    var leftPosition = list.style.left ? parseInt(list.style.left, 10) : 0;
    return leftPosition + (nav.offsetWidth / nbrWidthPart) * sign;
};
/**
 * Handle resize window
 *
 * @param callback
 */
var resizeWindowHandler = function (callback) {
    var list = getList();
    if (list) {
        list.style.left = '0px';
    }
    initButton();
    callback();
};
/**
 * Init galaxy top menu user interaction
 *
 * @param galaxy
 */
export var initTopMenu = function (galaxy) {
    if (galaxy) {
        var nav_1 = getNav();
        var list_1 = getList();
        var galaxyButtons = getButtonControls();
        if (list_1 && galaxyButtons && nav_1) {
            if (list_1.offsetWidth > nav_1.offsetWidth) {
                galaxyButtons.style.display = 'block';
            }
            else {
                galaxyButtons.style.display = 'none';
            }
        }
        var max_1 = false;
        var previousBtn_1 = getPreviousButton();
        var nextBtn_1 = getNextButton();
        if (previousBtn_1 && nextBtn_1) {
            initButton();
        }
        window.onresize = function () { return resizeWindowHandler(function () { return initTopMenu(galaxy); }); };
        if (previousBtn_1 && list_1 && nav_1) {
            previousBtn_1.onclick = function () {
                var listPositionLeft = list_1.style.left ? parseInt(list_1.style.left, 10) : 0;
                if (listPositionLeft < 0 && nextBtn_1) {
                    nextBtn_1.disabled = false;
                    max_1 = false;
                    if (list_1 && !list_1.style.left) {
                        list_1.style.left = '0px';
                    }
                    var newLeftPosition = getNextLeftPosition(list_1, nav_1);
                    if (newLeftPosition > 0) {
                        newLeftPosition = 0;
                        previousBtn_1.disabled = true;
                    }
                    list_1.style.left = newLeftPosition + "px";
                }
            };
        }
        if (nextBtn_1 && list_1 && nav_1) {
            nextBtn_1.onclick = function () {
                if (!list_1.style.left) {
                    list_1.style.left = '0px';
                }
                if (previousBtn_1) {
                    previousBtn_1.disabled = false;
                }
                var newLeftPosition = getNextLeftPosition(list_1, nav_1, true);
                if (!max_1) {
                    list_1.style.left = newLeftPosition + "px";
                }
                if (newLeftPosition < nav_1.offsetWidth - list_1.offsetWidth) {
                    max_1 = true;
                    nextBtn_1.disabled = true;
                }
            };
        }
    }
};
//# sourceMappingURL=Galaxy.functions.js.map